import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch} from "react-redux";
import * as actions from '../../../../actions/player-search';
import classNames from "classnames";
import styles from "../../../../components/dropdown/dropdown.module.css";
import {DebounceInput} from "react-debounce-input";
import ClickOutside from "../../../../components/ClickOutside";
import {detectIconById} from "../../../../common/enum";

function PlayerCondition(props) {
    const {selected, focus, error} = props;
    const dispatch = useDispatch();
    const [togglePlayer, setTogglePlayer] = useState(false);
    const [toggleOppPlayer, setToggleOppPlayer] = useState(false);
    const [choosePlayer, setChoosePlayer] = useState(selected.player);
    const [chooseOppPlayer, setChooseOppPlayer] = useState(selected.oppPlayer);
    const [condition, setCondition] = useState({
        player: [],
        oppPlayer: [],
    });
    let [suggestPlayer, setSuggestPlayer] = useState([]);
    const [suggestOppPlayer, setSuggestOppPlayer] = useState([]);
    const ref = useRef();
    const onAddPlayer = useCallback((player) => {
        const players = [...choosePlayer];
        if (players.find(item => item.id === player.id)) return;
        players.push(player);
        setTogglePlayer(false);
        setChoosePlayer(players)
    }, [choosePlayer]);

    const onAddOppPlayer = useCallback((player) => {
        const oppPlayers = [...chooseOppPlayer];
        if (oppPlayers.find(item => item.id === player.id)) return;
        oppPlayers.push(player);
        setToggleOppPlayer(false)
        setChooseOppPlayer(oppPlayers)
    }, [chooseOppPlayer]);

    const onRemoveChoosePlayer = useCallback((index) => {
        const players = [...choosePlayer];
        players.splice(index, 1);
        setChoosePlayer(players);
    }, [choosePlayer]);

    const onRemoveChooseOppPlayer = useCallback((index) => {
        const oppPlayers = [...chooseOppPlayer];
        oppPlayers.splice(index, 1);
        setChooseOppPlayer(oppPlayers)
    }, [chooseOppPlayer]);

    const search = useCallback(async (keyword, type) => {
        try {
            const result = await dispatch(actions.getPlayers(keyword));
            if (type === "player") {
                setTogglePlayer(true);
                setSuggestPlayer(result);
                return;
            }
            setToggleOppPlayer(true);
            setSuggestOppPlayer(result)
        } catch (e) {
            console.log(e)
        }
    }, [props]);
    useEffect(() => {
        if (focus === 'teamIds')
            ref.current.scrollIntoView({behavior: "smooth"});
    }, [focus])
    useEffect(() => {
        const tmp = [];
        choosePlayer.map((val) => {
            tmp.push(val);
        })
        setCondition((state) => ({player: tmp, oppPlayer: state.oppPlayer}))
    }, [choosePlayer])
    useEffect(() => {
        const tmp = [];
        chooseOppPlayer.map((val) => {
            tmp.push(val);
        })
        setCondition((state) => ({oppPlayer: tmp, player: state.player}))
    }, [chooseOppPlayer])
    useEffect(() => {
        props.onChange(condition)
    }, [condition])
    return <>
        <div>
            <label className="radio-detailed-search">選手
                <input type="radio" defaultChecked="checked" name="radio-1"/>
                <span className="checkmark"/>
            </label>
        </div>
        <div>
            <div style={{position: 'relative'}}>
                <div className="search-input-advanced">
                    <DebounceInput
                        style={{outline: 'none'}}
                        onFocus={(e) => {
                            if (!e.target.value) return;
                            search(e.target.value, 'player');
                        }}
                        placeholder="選手選択"
                        minLength={2}
                        debounceTimeout={500}
                        onChange={e => {
                            // setValue(e.target.value);
                            if (!e.target.value) return;
                            search(e.target.value, 'player');
                        }}/>
                    <img alt="search" src="/img/ic_search_svg.svg" className="position-absolute"/>
                </div>
                <div className='wrap-label-delete'>
                    {
                        choosePlayer.map((val, index) => {
                            return (
                                <div className='label-delete' key={index}>
                                    <span>{val.player_name}</span>
                                    <img alt="delete" src="/img/navigation/cancel_24px.svg"
                                         onClick={() => onRemoveChoosePlayer(index)}/>
                                </div>
                            )
                        })
                    }
                </div>
                <ClickOutside onClickOutside={() => setTogglePlayer(false)}>
                    <div
                        className={classNames(styles.blockSuggest, styles.dropdownMenu, togglePlayer && styles.displayBlock)}>
                        {
                            suggestPlayer.map((suggestion, index) => {
                                return (
                                    <div onClick={() => onAddPlayer(suggestion)} className={styles.dropdownMenuItem}
                                         key={index}>
                                        <div>
                                            <img style={{width: 20, marginRight: 10}}
                                                 src={detectIconById(suggestion.team.id)} alt="team-name"/>
                                            {suggestion.player_name}
                                            <span style={{
                                                color: '#74818A',
                                                fontSize: 13,
                                                marginLeft: 10
                                            }}>{suggestion.uniform_number}</span>
                                        </div>
                                        <span className="fa fa-search form-control-feedback"/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </ClickOutside>
            </div>
            <p style={{paddingBottom: 20, fontSize: '14px'}}>対戦選手</p>
            <div style={{position: 'relative'}}>
                <div className="search-input-advanced">
                    <DebounceInput
                        style={{outline: 'none'}}
                        onFocus={(e) => {
                            if (!e.target.value) return;
                            search(e.target.value, 'oppPlayer');
                        }}
                        placeholder="選手選択"
                        minLength={2}
                        debounceTimeout={500}
                        onChange={e => {
                            // setValue(e.target.value);
                            if (!e.target.value) return;
                            search(e.target.value, 'oppPlayer');
                        }}/>
                    <img alt="search" src="/img/ic_search_svg.svg" className="position-absolute"/>
                </div>
                <div className='wrap-label-delete'>
                    {
                        chooseOppPlayer.map((val, index) => {
                            return (
                                <div className='label-delete' key={index}>
                                    <span>{val.player_name}</span>
                                    <img alt="delete" src="/img/navigation/cancel_24px.svg"
                                         onClick={() => onRemoveChooseOppPlayer(index)}/>
                                </div>
                            )
                        })
                    }
                </div>
                <ClickOutside onClickOutside={() => setToggleOppPlayer(false)}>
                    <div
                        className={classNames(styles.blockSuggest, styles.dropdownMenu, toggleOppPlayer && styles.displayBlock)}>
                        {
                            suggestOppPlayer.map((suggestion, index) => {
                                return (
                                    <div onClick={() => onAddOppPlayer(suggestion)} className={styles.dropdownMenuItem}
                                         key={index}>
                                        <div>
                                            <img style={{width: 20, marginRight: 10}}
                                                 src={detectIconById(suggestion.team.id)} alt="team-name"/>
                                            {suggestion.player_name}
                                            <span style={{
                                                color: '#74818A',
                                                fontSize: 13,
                                                marginLeft: 10
                                            }}>{suggestion.uniform_number}</span>
                                        </div>
                                        <span className="fa fa-search form-control-feedback"/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </ClickOutside>
            </div>
        </div>
        <div ref={ref} className='err-validate-advance-search'>
            {error && <h4 className='navbar-item err-label' style={{paddingLeft: 20, paddingBottom: 10}}>選手{error.message}</h4>}
        </div>
    </>
}

export default PlayerCondition;
